import { useMemo } from 'react';

import tradingDataStore from 'lib/stores/tradingData';
import { OrderbookCompaniesResponse } from 'global/Securities/types/api/orderbook';

import { STOCK_TYPE } from 'constants/trading';
import TableOHLC from './TableOHLC';
import TableSecure from './TableSecure';
import TableHeader from './TableHeader';

import { Wrapper } from './styled';
import useSecuritiesOrderbook from '../hooks/useSecuritiesOrderbook';
import tradingModalStore from '../store';

const TableOrderbook = () => {
  const { showOrderbook, symbol } = tradingModalStore();

  const [orderbookData, loading] = useSecuritiesOrderbook(
    symbol,
    !showOrderbook,
  );

  const companyData = tradingDataStore((s) => s.company.data);
  const isBidOfferEmpty = useMemo(
    () => !loading && !orderbookData?.bid && !orderbookData?.offer,
    [loading, !orderbookData?.bid, !orderbookData?.offer],
  );

  // check if not loading and orderbookData is not empty before render orderbook table
  if (!loading && Object.keys(orderbookData).length > 0) {
    return (
      <Wrapper>
        <TableHeader data={companyData} />
        <TableSecure
          data={orderbookData}
          loading={loading}
          isStock={companyData?.type_company?.toLowerCase() === STOCK_TYPE.saham}
        />
        <TableOHLC
          bid={orderbookData?.bid}
          offer={orderbookData?.offer}
          previous={orderbookData?.previous}
          loading={loading}
          isEmpty={isBidOfferEmpty}
          bestBidOffer={orderbookData?.iepiev?.best_bid_offer}
          marketStatus={companyData?.market_hour?.status}
        />
      </Wrapper>
    );
  }

  return <></>;
};

export default TableOrderbook;
